module.exports = __webpack_public_path__ + "img/qrcode-as.b7feddfa.png";